/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Scope_PersonalInputs */



/**
* | output |
* | --- |
* | "Just for me" |
*
* @param {Settings_Template_Scope_PersonalInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_scope_personal = /** @type {((inputs?: Settings_Template_Scope_PersonalInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Scope_PersonalInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Alleen voor mij")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rien que pour moi")
	return /** @type {LocalizedString} */ ("Just for me")
});